import React from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import { ReactComponent as OwIcon } from "assets/img/owIconLogoColored.svg";
import { ReactComponent as OwLogo } from "assets/img/owLogoColored.svg"
import { OcPageTransition } from "oc/components";
import { useOcIsMobile } from "oc/hooks/use-is-mobile";

type MyHRErrorPageProps = {
  errorState: boolean;
  errorStateDb: boolean;
  errorStateType: string;
  apiUrl: string;
};

export const MyHRErrorPage = ({
  errorState,
  errorStateDb,
  errorStateType,
  apiUrl,
}: MyHRErrorPageProps) => {
  const isMobile = useOcIsMobile();
  const { t } = useTranslation();

  return (
    <OcPageTransition>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        style={{
          width: "100%",
          height: isMobile ? "auto" : "100vh",
          backgroundColor: "#F1F3F4",
          fontSize: "34px",
        }}
      >
        <Box id="orgware-logo" style={{ marginBottom: "24px" }}>
          <OwIcon />
        </Box>
        <Box
          id="orgware-text-logo"
          style={{ width: "350px", marginBottom: "15px" }}
        >
          <OwLogo />
        </Box>
        {(errorState || errorStateDb) && errorStateType === "net"
          ? t("OC_CONNECTION_ERROR")
          : t("OC_DB_CONNECTION_ERROR")}

        <Box height="24px" />
        <Box fontSize="24px">{apiUrl}</Box>
      </Box>
    </OcPageTransition>
  );
};

export default MyHRErrorPage;
